// extracted by mini-css-extract-plugin
export var downArrow = "_9g-0";
export var label = "_9g-1";
export var treatmentCard = "_9g-3";
export var upArrow = "_9g-2";